<template>
	<div class="bg-white px-3 index">
		<div class="add_tits" ref="title">
			<el-form class="form-inlines" :inline="true">
				<el-form-item label="姓名:">
					<el-input v-model="formData.keyword" placeholder="请输入内容" size="small"></el-input>
				</el-form-item>
				<el-form-item label="入驻时间:">
					<el-date-picker v-model="formData.time" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="医院:">
					<el-select v-model="formData.hosname" placeholder="请选择" size="small" filterable clearable>
						<el-option v-for="item in  formData.hos_options" :key="item.id" :label="item.hospital_name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="省:">
					<el-select v-model="formData.province" placeholder="请选择" size="small" filterable clearable
						@change="getsq">
						<el-option v-for="item in  formData.pro_options" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="市:">
					<el-select v-model="formData.city" placeholder="请选择" size="small" filterable clearable>
						<el-option v-for="item in  formData.city_options" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="职称:">
					<el-cascader :options="formData.job_options" v-model="formData.jobname" clearable size="small"
						:props="{value:'id', label:'name', children:'children'}"></el-cascader>
				</el-form-item>
				<el-form-item label="科室:">
					<el-cascader :options="formData.ks_options" v-model="formData.ksname" clearable size="small"
						:props="{value:'id', label:'name', children:'children'}"></el-cascader>
				</el-form-item>
				<el-form-item label="渠道来源:">
					<el-select v-model="formData.qdname" placeholder="请选择" size="small" filterable clearable>
						<el-option label="自然入驻" value="1"></el-option>
						<el-option label="裂变入驻" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="邀请人:">
					<el-select v-model="formData.yqrname" placeholder="请选择" size="small" filterable clearable>
						<el-option v-for="item in  formData.yq_options" :key="item.inviter_ids"
							:label="item.inviter_nickname" :value="item.inviter_ids">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="ibox-content" v-loading="dcing">
			<div class="b_top u-f u-jsb">
				<el-button icon="el-icon-printer" :loading='dcing' size="mini" @click="exportExcel">
					导出Excel</el-button>
				<div>
					<el-button :loading='dcing' type="" size="mini" @click="setOneMoney(1)">
						设为1元咨询</el-button>
					<el-button :loading='dcing' type="" size="mini" @click="setOneMoney(0)">
						恢复为原价</el-button>
				</div>

			</div>
			<el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable"
				@selection-change="handleSelectionChange" :row-key="getRowKeys">
				<el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
				<el-table-column prop="id" label="ID" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="user_id" label="医生ID" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="create_time" label="申请入驻日期" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="addressee" label="用户属性" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="real_name" label="真实姓名" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="identity_card" label="身份证号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="hospital_id_text" label="医院" show-overflow-tooltip></el-table-column>
				<el-table-column prop="address" label="地区" show-overflow-tooltip>
					<template slot-scope="scope">
						<template v-if="scope.row.hospital">
							{{scope.row.hospital.province_code_text}}-{{scope.row.hospital.city_code_text}}-{{scope.row.hospital.area_code_text}}
						</template>
					</template>
				</el-table-column>
				<el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="department_id_text" label="科室" show-overflow-tooltip></el-table-column>
				<el-table-column prop="certificate_code" label="执业证书编码" show-overflow-tooltip></el-table-column>
				<el-table-column prop="examine_text" label="审核状态" show-overflow-tooltip></el-table-column>
				<el-table-column prop="examine_time" label="入驻日期" show-overflow-tooltip></el-table-column>
				<el-table-column prop="source_str" label="渠道来源" show-overflow-tooltip></el-table-column>
				<el-table-column prop="inviter_nickname" label="邀请人" show-overflow-tooltip></el-table-column>
				<el-table-column label="操作" align="center" width="120" fixed="right">
					<template slot-scope="{row,$index}">
						<el-button size="mini" type="text" @click="handleEdit($index, row)">编辑
						</el-button>
						<el-dropdown trigger="click" style="margin-left:10px">
							<span class="el-dropdown-link">
								更多<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item><span @click="baodaoCode('home', row)">主页二维码</span>
								</el-dropdown-item>
								<el-dropdown-item><span @click="baodaoCode('Internet_hospital', row)">互联网医院二维码</span>
								</el-dropdown-item>
								<el-dropdown-item v-if="row.examine == 1"><span
										@click="baodaoCode('Check', row)">报到二维码</span></el-dropdown-item>
								<el-dropdown-item v-if="row.examine == 1"><span
										@click="handleInvite($index, row)">邀请记录</span></el-dropdown-item>
								<el-dropdown-item><span @click="handleEditzs(row,$index)">证书编码</span></el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>

		</div>

		<div v-show="false">
			<el-table :data="tableData2" border v-loading="loading" :height="heights" id="out-table">
				<el-table-column prop="create_time" label="申请入驻日期" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="addressee" label="用户属性" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="real_name" label="真实姓名" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="identity_card" label="身份证号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="hospital_id_text" label="医院" show-overflow-tooltip></el-table-column>
				<el-table-column prop="address" label="地区" show-overflow-tooltip>
					<template slot-scope="scope">
						<span
							v-if="scope.row.hospital">{{scope.row.hospital.province_code_text}}-{{scope.row.hospital.city_code_text}}-{{scope.row.hospital.area_code_text}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="department_id_text" label="科室" show-overflow-tooltip></el-table-column>
				<el-table-column prop="certificate_code" label="执业证书编码" show-overflow-tooltip></el-table-column>
				<el-table-column prop="examine_text" label="审核状态" show-overflow-tooltip></el-table-column>
				<el-table-column prop="examine_time" label="入驻日期" show-overflow-tooltip></el-table-column>
				<el-table-column prop="source_str" label="渠道来源" show-overflow-tooltip></el-table-column>
				<el-table-column prop="inviter_nickname" label="邀请人" show-overflow-tooltip></el-table-column>

			</el-table>
		</div>
		<!--编辑  -->
		<el-dialog title="医生编辑" :visible.sync="dialog_info" width="80%" center top="5vh">
			<div class="dialog-ibox-content">
				<el-form ref="formed" :model="formed" label-width="140px" :rules="rule" class="forms-inlines">
					<el-row>
						<el-col :span="12">
							<el-form-item label="真实姓名" prop="username">
								<el-input v-model="formed.username" placeholder="真实姓名" size="small">
								</el-input>
							</el-form-item>
							<el-form-item label="身份证号码" prop="userId">
								<el-input v-model="formed.userId" placeholder="身份证号码" size="small">
								</el-input>
							</el-form-item>
							<el-form-item label="手机号码" prop="phone">
								<el-input v-model="formed.phone" placeholder="手机号码" size="small">
								</el-input>
							</el-form-item>
							<el-form-item label="医院" prop="hospital" v-if="source == 1">
								<el-select v-model="formed.hospital" size="small" placeholder="请选择医院">
									<el-option v-for="(item, index) in hos_options" :key="index"
										:label="item.hospital_name" :value="item.id">
									</el-option>
								</el-select>
								<span style="margin-left: 10px">
									<el-button type="primary" size="small" @click="gohosid">跳转医院设置</el-button>
								</span>
							</el-form-item>
							<el-form-item label="未查询到医院名" v-if="formed.new_hospital && source == 1">
								<el-input v-model="formed.new_hospital" placeholder="医院名称" size="small"></el-input>
							</el-form-item>
							<el-form-item label="职称" prop="doctitle">
								<el-cascader v-model="formed.doctitle" size="small"
									:props="{ value: 'id', label: 'name' }" :options="doctitle_options"
									@change="doctitleChange"></el-cascader>
							</el-form-item>
							<el-form-item label="科室" prop="department">
								<el-cascader v-model="formed.department" size="small"
									:props="{ value: 'id', label: 'name' }" :options="depat_options"
									@change="depatChange">
								</el-cascader>
							</el-form-item>
							<el-form-item label="简介" prop="brief">
								<el-input type="textarea" :autosize="false" resize="none" :rows="3" placeholder="请输入简介"
									v-model="formed.brief">
								</el-input>
							</el-form-item>
							<el-form-item label="擅长" prop="goodat">
								<el-input type="textarea" :autosize="false" resize="none" :rows="3" placeholder="请输入擅长"
									v-model="formed.goodat">
								</el-input>
							</el-form-item>
							<el-form-item label="好评率" prop="goodnum">
								<el-input v-model="formed.goodnum" placeholder="好评率%" size="mini"></el-input>
							</el-form-item>
							<el-form-item label="服务患者数量" prop="servicenum">
								<el-input v-model="formed.servicenum" placeholder="服务患者数量" size="mini"></el-input>
							</el-form-item>
							<el-form-item label="完成问诊咨询" prop="doneuser">
								<el-input v-model="formed.doneuser" placeholder="完成问诊咨询" size="mini"></el-input>
							</el-form-item>
							<el-form-item label="图文咨询费用" prop="tw_mon">
								<el-input v-model="formed.tw_mon" placeholder="元" type="number" size="mini" min="0">
								</el-input>
							</el-form-item>
							<el-form-item label="语音咨询费用" prop="yy_mon">
								<el-input v-model="formed.yy_mon" placeholder="元" type="number" size="mini" min="0">
								</el-input>
							</el-form-item>
							<el-form-item label="视频咨询费用" prop="sp_mon">
								<el-input v-model="formed.sp_mon" placeholder="元" type="number" size="mini" min="0">
								</el-input>
							</el-form-item>
							<el-form-item label="在线问诊链接">
								<el-input v-model="formed.doctor_inquiry_url" placeholder="" type="text" size="mini">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="头像" prop="tx_mapList">
								<el-upload class="avatar-uploader" :limit="1" action="/admin/uploadFile" name="img"
									ref="upload" :headers="{ token: $store.state.user.token }"
									:data="{ image_class_id: '53', file_type: '1' }" :file-list="formed.tx_mapList"
									:on-success="handleAvatarSuccess" :on-remove="uploadRmove" list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
							<el-form-item label="身份证图片" prop="id_mapList">
								<el-upload class="avatar-uploader" :limit="2" action="/admin/uploadFile" name="img"
									ref="upload" :headers="{ token: $store.state.user.token }"
									:data="{ image_class_id: '53', file_type: '1' }" :file-list="formed.id_mapList"
									:on-success="handleAvatarSuccess2" :on-remove="uploadRmove2"
									list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
							<el-form-item :label="source == 1 ? '医生执业证书' : '心理咨询师证书'" prop="zyzs_mapList">
								<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
									:headers="{ token: $store.state.user.token }"
									:data="{ image_class_id: '53', file_type: '1' }" :file-list="formed.zyzs_mapList"
									:on-success="handleAvatarSuccess3" :on-remove="uploadRmove3"
									list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
							<el-form-item label="医生资格证书" prop="zg_mapList" v-if="source == 1">
								<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
									:headers="{ token: $store.state.user.token }"
									:data="{ image_class_id: '53', file_type: '1' }" :file-list="formed.zg_mapList"
									:on-success="handleAvatarSuccess4" :on-remove="uploadRmove4"
									list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
							<el-form-item label="医生职称证书" v-if="source == 1">
								<el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
									:headers="{ token: $store.state.user.token }"
									:data="{ image_class_id: '53', file_type: '1' }" :file-list="formed.zc_mapList"
									:on-success="handleAvatarSuccess5" :on-remove="uploadRmove5"
									list-type="picture-card">
									<i class="el-icon-plus"></i>
								</el-upload>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="editSubmit('formed')" size="small">确 定</el-button>
				<el-button @click="dialog_info = false" size="small">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="邀请医生记录" :visible.sync="dialog_invite" center top="5vh" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content">
				<invitable :key="invitindex" :doc_id="doc_id"></invitable>
			</div>
			<el-divider></el-divider>
		</el-dialog>
		<!-- 报到二维码 -->
		<el-dialog :title="ewmText" :visible.sync="dialogCode" width="40%" center top="5vh" class="dialogs">
			<el-divider></el-divider>
			<div class="dialog-ibox-content" v-loading='ewmloading'>
				<div class="codeImg">
					<img :src="bdcode" alt="" style="    width: 100%;" />
				</div>
			</div>
			<el-divider></el-divider>
		</el-dialog>

	</div>
</template>


<script>
	import {
		mapState
	} from 'vuex'
	import invitable from "../../../components/settle/table";
	export default {
		components: {
			invitable
		},
		data() {
			return {
				formData: {
					time: '',
					hosname: '',
					hos_options: [],
					province: '',
					pro_options: [],
					city: '',
					city_options: [],
					jobname: '',
					job_options: [],
					ksname: '',
					ks_options: [],
					qdname: '',
					qd_options: [],
					yqrname: '',
					yq_options: [],
					keyword: '',
				},
				loading: false,
				dcing: false,
				tableData: [],
				tableData2: [],
				currentPage: 1,
				pagesize: 15,
				count: 0,
				heights: null,
				formed: {
					department: [],
					doctitle: [],
					hospital: "",
					email: "",
					userId: "",
					phone: "",
					username: "",
					goodat: "",
					brief: "",
					zc_mapList: [],
					zg_mapList: [],
					zyzs_mapList: [],
					id_mapList: [],
					tx_mapList: [],
					doneuser: "",
					servicenum: "",
					goodnum: "",
					new_hospital: "",
					tw_mon: 0,
					yy_mon: 0,
					sp_mon: 0,
					doctor_inquiry_url: '',
				},
				rule: {
					result: [{
						required: true,
						message: "请填写拒绝通过的理由",
						trigger: "blur",
					}, ],
					department: [{
						required: true,
						message: "请选择科室",
						trigger: "blur",
					}, ],
					doctitle: [{
						required: true,
						message: "请选择职称",
						trigger: "blur",
					}, ],
					hospital: [{
						required: true,
						message: "请选择医院",
						trigger: "blur",
					}, ],

					userId: [{
						required: true,
						message: "请填写身份证号码",
						trigger: "blur",
					}, ],
					phone: [{
						required: true,
						message: "请填写手机号码",
						trigger: "blur",
					}, ],
					username: [{
						required: true,
						message: "请填写真实姓名",
						trigger: "blur",
					}, ],
					goodat: [{
						required: true,
						message: "请填写擅长",
						trigger: "blur",
					}, ],
					brief: [{
						required: true,
						message: "请填写简介",
						trigger: "blur",
					}, ],

					zg_mapList: [{
						required: true,
						message: "请添加资格证书",
						trigger: "blur",
					}, ],
					zyzs_mapList: [{
						required: true,
						message: "请添加职业证书",
						trigger: "blur",
					}, ],
					id_mapList: [{
						required: true,
						message: "请添加身份证照片",
						trigger: "blur",
					}, ],
					tx_mapList: [{
						required: true,
						message: "请添加头像",
						trigger: "blur",
					}, ],
					doneuser: [{
						required: true,
						message: "请输入完成用户名",
						trigger: "blur",
					}, ],
					servicenum: [{
						required: true,
						message: "请输入服务数量",
						trigger: "blur",
					}, ],
					goodnum: [{
						required: true,
						message: "请输入好评率",
						trigger: "blur",
					}, ],
					tw_mon: [{
						required: true,
						message: "请设置图文咨询费用",
						trigger: "blur",
					}, ],
					yy_mon: [{
						required: true,
						message: "请设置语音咨询费用",
						trigger: "blur",
					}, ],
					sp_mon: [{
						required: true,
						message: "请设置视频咨询费用",
						trigger: "blur",
					}, ],
				},
				mapListed: [],
				mapListed2: [],
				mapListed3: [],
				mapListed4: [],
				mapListed5: [],
				eid: "",
				dialog_info: false,
				userid: "",
				userinfoid: "",
				doctitids: "",
				doctitid: "",
				departids: "",
				departid: "",
				source: 1,
				depat_options: [],
				doctitle_options: [],
				hos_options: [],
				dialog_invite: false,
				invitindex: 0,
				doc_id: "",
				bdcode: "",
				dialogCode: false,
				multipleSelection: [],
				ewmText: '报到二维码',
				ewmloading: false
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getall()
			that.getHeight()
			that.begin()
		},
		methods: {
			// 获取高度
			getHeight() {
				let that = this;
				var title = that.$refs.title.offsetHeight
				that.heights = window.innerHeight - title - 250 + 'px'
				window.onresize = () => {
					var title = that.$refs.title.offsetHeight
					that.heights = window.innerHeight - title - 250 + 'px'
				}
			},
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			search() {
				let that = this
				that.loading = true
				axios
					.post("/admin/DoctorAudit/doctorDetailReport", {
						page: that.currentPage,
						page_count: that.pagesize,
						province_code: this.formData.province,
						city_code: this.formData.city,
						start_time: this.formData.time[0] ? this.formData.time[0] : '',
						end_time: this.formData.time[1] ? this.formData.time[1] : '',
						hospital_id: this.formData.hosname,
						competent_id: this.formData.jobname ? this.formData.jobname[this.formData.jobname.length - 1] :
							'',
						department_id: this.formData.ksname ? this.formData.ksname[this.formData.ksname.length - 1] :
							'',
						source: this.formData.qdname,
						inviter_ids: this.formData.yqrname,
						keyword: this.formData.keyword
					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.list
						that.count = response.data.data.totalCount
					})
					.catch(error => {})
			},
			search2(page) {
				let that = this
				that.loading = true
				axios
					.post("/admin/DoctorAudit/doctorDetailReport", {
						page: page,
						page_count: 15,
						province_code: '',
						city_code: '',
						start_time: '',
						end_time: '',
						hospital_id: '',
						competent_id: '',
						department_id: '',
						source: '',
						inviter_ids: ''
					}, {
						token: true
					})
					.then(response => {
						that.loading = false
						that.tableData = response.data.data.list
						that.count = response.data.data.totalCount
					})
					.catch(error => {})
			},
			handleEdit(index, row) {
				let that = this;
				this.eid = row.id;
				this.source = row.source;
				this.userid = row.user_id;
				this.userinfoid = row.user_info_id;
				this.examine = row.examine;

				this.jbxxItem = "";
				axios
					.post(
						"/admin/doctorAudit/readExamine", {
							id: that.eid,
							source: row.source
						}, {
							token: true,
						}
					)
					.then((response) => {
						var data = response.data.data;
						if (data) {
							// that.form.examine = data.examine
							// that.form.result = data.examine == '1' ? '' : data.examine_result
						} else {
							that.eid = "";
						}
						that.formed.tx_mapList = data.head_portrait_pic;
						that.mapListed = data.head_portrait_pic;
						that.formed.id_mapList = data.identity_card_pic;
						that.mapListed2 = data.identity_card_pic;
						that.formed.zyzs_mapList = data.physician_card_pic;
						that.mapListed3 = data.physician_card_pic;
						that.formed.zg_mapList = data.physician_seniority_pic;
						that.mapListed4 = data.physician_seniority_pic;
						that.formed.zc_mapList = data.competent_certificate_pic;
						that.mapListed5 = data.competent_certificate_pic;

						that.formed.goodat = data.good_at;
						that.formed.brief = data.introduction;

						that.formed.goodnum = data.praise;
						that.formed.servicenum = data.service_count;
						that.formed.doneuser = data.consultation_log;

						this.doctitid = data.competent_id;
						this.doctitids = data.competent_ids;
						this.departid = data.department_id;
						this.departids = data.department_ids;

						this.formed.tw_mon = data.picture_consultation - 0;
						this.formed.yy_mon = data.voice_consultation - 0;
						this.formed.sp_mon = data.video_consultation - 0;

						that.formed.department = data.department_ids.split(",").map(Number); //科室id
						that.formed.doctitle = data.competent_ids.split(",").map(Number); //职称id
						that.formed.doctor_inquiry_url = data.doctor_inquiry_url
					})
					.catch((error) => {});

				that.formed.username = row.real_name; //申请人姓名
				that.formed.userId = row.identity_card; //身份证号
				that.formed.phone = row.phone; //手机号
				that.formed.hospital = row.hospital_id ? row.hospital_id : ""; //第一执业医院
				that.formed.new_hospital = row.hospital_id ? "" : row.new_hospital;



				that.dialog_info = true;
			},
			editSubmit(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						axios
							.post(
								"/admin/doctorAudit/editAudit", {
									id: that.eid,
									user_id: that.userid, // 账号id 登录信息里的id
									user_info_id: that.userinfoid, //基本信息id 登录信息里userinfo里的id
									real_name: that.formed.username, //申请人姓名
									identity_card: that.formed.userId, //身份证号
									phone: that.formed.phone, //手机号
									consultation_log: that.formed.doneuser - 0, //完成咨询人
									service_count: that.formed.servicenum, //服务数量
									praise: that.formed.goodnum, //好评率
									hospital_id: that.formed.hospital, //第一执业医院
									department_id: that.departid, //科室id
									department_ids: that.departids, // 所选科室第一级id拼接第二级id 入 32,33
									competent_id: that.doctitid, //职称id
									competent_ids: that.doctitids, //职称层级id 如1,2
									identity_card_pic: that.mapListed2, //身份证图片
									head_portrait_pic: that.mapListed, //头像图片
									physician_card_pic: that.mapListed3, //医师执业证书
									physician_seniority_pic: that.mapListed4, //医师资格证书
									competent_certificate_pic: that.mapListed5, //医师职称证书
									// examine: that.form.examine,
									// examine_result: that.form.result,
									good_at: that.formed.goodat, //擅长
									introduction: that.formed.brief, //介绍
									author: that.user.id,
									new_hospital: this.new_hospital,
									picture_consultation: that.formed.tw_mon,
									voice_consultation: that.formed.yy_mon,
									video_consultation: that.formed.sp_mon,
									source: this.source,
									doctor_inquiry_url: this.formed.doctor_inquiry_url
								}, {
									token: true,
								}
							)
							.then((response) => {
								if (response.data.code == "200") {
									that.dialog_info = false;
									that.search();
									that.$message({
										message: "操作成功",
										type: "success",
									});
								} else {
									that.$message.error(response.data.msg);
								}
							})
							.catch((error) => {});
					} else {
						that.$alert("信息遗漏未填");
						return false;
					}
				});
			},
			async exportExcel() {
				// var fix = document.querySelector('.el-table__fixed-right');
				let tabs = []
				let pages = Math.ceil(this.count / 15)
				this.dcing = true
				this.loading = true
				for (let i = 1; i <= pages; i++) {
					let res = await new Promise(ok => {
						axios
							.post("/admin/DoctorAudit/doctorDetailReport", {
								page: i,
								page_count: 15,
								province_code: '',
								city_code: '',
								start_time: '',
								end_time: '',
								hospital_id: '',
								competent_id: '',
								department_id: '',
								source: '',
								inviter_ids: ''
							}, {
								token: true
							})
							.then(ok)
							.catch(error => {})
					})
					tabs = tabs.concat(res.data.data.list)
				}
				if (tabs && tabs.length > 0) {
					this.dcing = false
					this.loading = false
					this.tableData2 = tabs
					this.$nextTick(() => {
						var xtable = document.querySelector('#out-table')
						this.$excels.exports(xtable, '医生明细')
					})
				}


			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			handleEditzs(row, index) {
				this.$prompt('请输入执业证书编码', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /\S/,
					inputErrorMessage: '执业证书编码不能为空'
				}).then(({
					value
				}) => {
					axios
						.post("/admin/pc/doctorAudit/updateCertificateCode", {
							certificate_code: value,
							id: row.id
						}, {
							token: true
						}).then(response => {
							this.search()
							this.$message({
								type: 'success',
								message: '操作成功'
							});
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			getall() {
				this.gethos()
				this.getjob()
				this.getks()
				this.getyqxx()
				this.all_sheng()
			},
			gethos() {
				axios
					.post("/admin/HospitalSelect", {}, {
						token: true
					})
					.then(response => {
						this.formData.hos_options = response.data.data
						this.hos_options = response.data.data
					})
					.catch(error => {})
			},
			getjob() {
				axios
					.post("/admin/showCompetentList", {}, {
						token: true
					})
					.then(response => {
						this.formData.job_options = response.data.data
						this.formData.job_options = this.IterDelateChildren(this.formData.job_options)
						this.doctitle_options = this.IterDelateChildren(response.data.data);
					})
					.catch(error => {})
			},
			getks() {
				axios
					.post("/admin/showSectionList", {}, {
						token: true
					})
					.then(response => {
						this.formData.ks_options = response.data.data
						this.formData.ks_options = this.IterDelateChildren(this.formData.ks_options)
						this.depat_options = this.IterDelateChildren(response.data.data);
					})
					.catch(error => {})
			},
			IterDelateChildren(arr) {
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].children) {
						if (arr[i].children.length) {
							this.IterDelateChildren(arr[i].children)
						} else {
							delete arr[i].children
						}
					}
				}
				return arr
			},
			getyqxx() {
				axios
					.post("/admin/DoctorAudit/inviterSelect", {}, {
						token: true
					})
					.then(response => {
						this.formData.yq_options = response.data.data
					})
					.catch(error => {})
			},
			//省
			all_sheng() {
				let that = this
				axios
					.post("/admin/Area/getProvince_vue", {}, {
						token: true
					})
					.then(response => {
						that.formData.pro_options = response.data.data
					})
					.catch(error => {})
			},
			// 市
			getsq() {
				let that = this
				that.formData.city = ''
				that.formData.city_options = []
				axios
					.post("/admin/Area/getChild_vue", {
						parentcode: that.formData.province,
					}, {
						token: true
					})
					.then(response => {
						that.formData.city_options = response.data.data
					})
					.catch(error => {})
			},

			handleAvatarSuccess(res, file, fileList) {
				let that = this;
				if (res.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1);
								}
							});
						}
					});
					that.$alert(res.msg);
					return;
				}
				that.$message({
					message: "上传成功",
					type: "success",
				});
				that.mapListed.push(res.data);
			},
			handleAvatarSuccess2(res, file, fileList) {
				let that = this;
				if (res.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1);
								}
							});
						}
					});
					that.$alert(res.msg);
					return;
				}
				that.$message({
					message: "上传成功",
					type: "success",
				});
				that.mapListed2.push(res.data);
			},
			handleAvatarSuccess3(res, file, fileList) {
				let that = this;
				if (res.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1);
								}
							});
						}
					});
					that.$alert(res.msg);
					return;
				}
				that.$message({
					message: "上传成功",
					type: "success",
				});
				that.mapListed3.push(res.data);
			},
			handleAvatarSuccess4(res, file, fileList) {
				let that = this;
				if (res.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1);
								}
							});
						}
					});
					that.$alert(res.msg);
					return;
				}
				that.$message({
					message: "上传成功",
					type: "success",
				});
				that.mapListed4.push(res.data);
			},
			handleAvatarSuccess5(res, file, fileList) {
				let that = this;
				if (res.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1);
								}
							});
						}
					});
					that.$alert(res.msg);
					return;
				}
				that.$message({
					message: "上传成功",
					type: "success",
				});
				that.mapListed5.push(res.data);
			},
			uploadRmove(file, fileList) {
				var index = this.mapListed.findIndex((item) => item.id == file.id);
				this.mapListed.splice(index, 1);
			},
			uploadRmove2(file, fileList) {
				var index = this.mapListed2.findIndex((item) => item.id == file.id);
				this.mapListed2.splice(index, 1);
			},
			uploadRmove3(file, fileList) {
				var index = this.mapListed3.findIndex((item) => item.id == file.id);
				this.mapListed3.splice(index, 1);
			},
			uploadRmove4(file, fileList) {
				var index = this.mapListed4.findIndex((item) => item.id == file.id);
				this.mapListed4.splice(index, 1);
			},
			uploadRmove5(file, fileList) {
				var index = this.mapListed5.findIndex((item) => item.id == file.id);
				this.mapListed5.splice(index, 1);
			},
			depatChange(val) {
				this.departid = val[val.length - 1];
				this.departids = val.toString();
			},
			doctitleChange(val) {
				this.doctitid = val[val.length - 1];
				this.doctitids = val.toString();
			},
			gohosid() {
				this.$router.push("/set/hospital");
			},
			handleInvite(index, row) {
				this.invitindex += 1;
				this.dialog_invite = true;
				this.doc_id = row.user_id;
			},
			baodaoCode(t, row) {
				//Check 报到二维码
				//home 主页二维码
				let params = {
					qrcode_name: "sign_qrcode.png",
					qrcode_content: "https://gzh.kkxxkj.cn/mycode/addpatient?id=",
					qrcode_poster: "sign_poster.png",
					backdrop: "storage/background/bgt18.png",
					bgt_width: 600,
					bgt_hight: 800,
					avatarWidth: 100,
					avatarY: 595,
					qrcodeWidth: 420,
					qrcodeY: 100,
					fontSize: 35,
					fontY: 560,
					qrcode_type: 2,
					docId: row.user_id,
				}
				let urls = '/admin/HgetQrcode'
				if (t == 'Check') {
					this.ewmText = '报到二维码'
				} else if (t == 'home') {
					this.ewmText = '主页二维码'
					params.qrcode_type = 19
				} else if (t == 'Internet_hospital') {
					this.ewmText = '互联网医院二维码'
					params.qrcode_type = 20
				}
				this.ewmloading = true
				this.dialogCode = true;
				axios
					.post(urls, params, {
						token: true,
					})
					.then((res) => {
						this.bdcode = res.data.data;
						this.ewmloading = false
					})
					.catch((error) => {});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			getRowKeys(row) {
				return row.id; // id为列表数据的唯一标识
			},
			setOneMoney(t) {
				if (this.multipleSelection.length == 0) return this.$message('请先选择医生')
				this.$confirm(`是否将批量医生咨询费用${t==0?'恢复为原价':'设置为1元'}, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let ids = this.multipleSelection.map(a => {
						return a.user_id
					})
					axios
						.post("/admin/doctorInfo/setOneConsult", {
							ids: ids,
							one_consult: t
						}, {
							token: true
						})
						.then(res => {
							if (res.data.code == 200) {
								this.$message.success('设置成功！')
							} else {
								this.$message(res.data.msg)
							}
							// this.$refs.configurationTable.clearSelection();

						})
						.catch(error => {})

				}).catch(() => {

				});
			},
		},
	};
</script>


<style lang="scss" scoped>
	.index {
		border-radius: 6px;
		padding-bottom: 10px;
	}

	.b_top {
		padding: 5px 0;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #5473E8;
		font-size: 12px;
	}
</style>